export enum MoneySource {
  MORTGAGE = 'MORTGAGE',
  PERSONAL = 'PERSONAL',
  SELLING_PERSONAL_PROPERTIES = 'SELLING_PERSONAL_PROPERTIES',
  OTHER = 'OTHER',
}

export enum GoodsSource {
  THIRD_PARTY_INCOME = 'THIRD_PARTY_INCOME',
  SUCCESSION_OR_DONATION = 'SUCCESSION_OR_DONATION',
  SELLING_PERSONAL_PROPERTIES = 'SELLING_PERSONAL_PROPERTIES',
  OTHER = 'OTHER',
}
export interface AntiMoneyLaundering {
  politicallyExposed?: boolean,
  relatedToAPoliticallyExposedFigure?: boolean,
  moneySources?: MoneySource[],
  goodsSources?: GoodsSource[],
  otherMoneySourceValue?: string,
  otherGoodsSourceValue?: string,
  notes?: string,
}
